/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepoStatus.defs.js'
export { main as default } from './getRepoStatus.defs.js'
